<template>
  <div>
    <v-list-item v-for="item in data" :key="item.created_at">
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ $t(`calltimeline.state.${item.state}`) }}
          </v-list-tile-title>
          <v-list-tile-sub-title>
            <date-formatter
              :value="item.created_at"
              format="precise">
            </date-formatter>
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-item>
  </div>
</template>

<script>
  import { Date as DateFormatter } from '@/components/formatters'
  export default {
    components: {
      DateFormatter
    },
    props: {
      data: {
        type: Array,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CallTimeline.vue